import { memo } from "react";
import { BzButton, BzChip, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../../components";
import { Container, Row, Col } from "react-bootstrap";
import { handleModal } from "../../../redux/actions/modals";
import { useDispatch, useSelector } from 'react-redux';


const FilterModal = ({ handleFiltersOnClick, activeFilters, setActiveFilters, handleOnFilterApply }) => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);

    const handleClose = () => {
        dispatch(handleModal([{ "FILTER_MODAL": false }]));
        setActiveFilters({});
    };


    return (
        <Row className='g-0'>
            <Col>
                <BzModal size='lg' show={modals['FILTER_MODAL']} onHide={handleClose} >
                    <BzModalHeader className='modaltabs-header'>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col md={11} className='d-flex justify-content-start align-self-center'>
                                    <div className='font-medium font-size4 color-text'>Filters</div>
                                </Col>
                                <Col md={1} className='d-flex justify-content-end align-self-center'>
                                    <div onClick={handleClose} className='icon-16 icon-close icon-dark'></div>
                                </Col>
                            </Row>
                        </Container>
                    </BzModalHeader>
                    <BzModalBody>
                        <Row className='g-0 mt-3'>
                            <Col>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className='font-medium font-size3 color-text'>AMC</div>
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    <Col className='multi-chips-wrap'>
                                        <BzChip onClick={() => { handleFiltersOnClick('amc', 'axis'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.amc === 'axis' ? 'active' : ''}`} >Axis</BzChip>
                                        <BzChip onClick={() => { handleFiltersOnClick('amc', 'adityaBirla'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.amc === 'adityaBirla' ? 'active' : ''}`}>Aditya Birla</BzChip>
                                        <BzChip onClick={() => { handleFiltersOnClick('amc', 'bob'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.amc === 'bob' ? 'active' : ''}`}>Bank of Baroda</BzChip>
                                        <BzChip onClick={() => { handleFiltersOnClick('amc', 'icci'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.amc === 'icci' ? 'active' : ''}`}>ICCI</BzChip>
                                        <BzChip onClick={() => { handleFiltersOnClick('amc', 'kotak'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.amc === 'kotak' ? 'active' : ''}`}>Kotak</BzChip>

                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row className='g-0 mt-3'>
                            <Col>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className='font-medium font-size3 color-text'>Category</div>
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    <Col className='multi-chips-wrap'>
                                        <BzChip onClick={() => { handleFiltersOnClick('category', 'equity'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.category === 'equity' ? 'active' : ''}`}>Equity</BzChip>
                                        <BzChip onClick={() => { handleFiltersOnClick('category', 'debt'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.category === 'debt' ? 'active' : ''}`}>Debt</BzChip>

                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row className='g-0 mt-3'>
                            <Col>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className='font-medium font-size3 color-text'>Sub Category</div>
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    <Col className='multi-chips-wrap'>
                                        <BzChip onClick={() => { handleFiltersOnClick('subcategory', 'largecap'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.subcategory === 'largecap' ? 'active' : ''}`}>Large Cap</BzChip>
                                        <BzChip onClick={() => { handleFiltersOnClick('subcategory', 'smallcap'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.subcategory === 'smallcap' ? 'active' : ''}`}>Small Cap</BzChip>
                                        <BzChip onClick={() => { handleFiltersOnClick('subcategory', 'midcap'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.subcategory === 'midcap' ? 'active' : ''}`}>Mid Cap</BzChip>
                                        <BzChip onClick={() => { handleFiltersOnClick('subcategory', 'elss'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.subcategory === 'elss' ? 'active' : ''}`}>ELSS</BzChip>
                                        <BzChip onClick={() => { handleFiltersOnClick('subcategory', 'balanced'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.subcategory === 'balanced' ? 'active' : ''}`}>Balanced</BzChip>

                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row className='g-0 mt-3'>
                            <Col>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className='font-medium font-size3 color-text'>Dividend Type</div>
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    <Col className='multi-chips-wrap'>
                                        <BzChip onClick={() => { handleFiltersOnClick('dividend', 'growth'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.dividend === 'growth' ? 'active' : ''}`}>Growth</BzChip>
                                        <BzChip onClick={() => { handleFiltersOnClick('dividend', 'idcw'); }} className={`multi-chip me-2 mb-2 font-size3 ${activeFilters.dividend === 'idcw' ? 'active' : ''}`}>IDCW</BzChip>

                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </BzModalBody>
                    <BzModalFooter className='bdr-none'>
                        <Container fluid className='m-0 p-0'>
                            <Row className='g-0 pb-2'>
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <BzButton className='btn btn-outline font-size2 me-3' onClick={() => { setActiveFilters(false); }}>Reset Filters</BzButton>
                                    <BzButton className='btn btn-primary font-size2' onClick={handleOnFilterApply}>Apply</BzButton>
                                </Col>
                            </Row>
                        </Container>
                    </BzModalFooter>
                </BzModal>

            </Col >

        </Row >
    );

};
export default memo(FilterModal)








